import React, { useEffect, useState } from "react";
import SummaryCards from "../../components/Common/SummaryCards";
import { Button, Container, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import {
  getApplicationRoles,
  getUsersList,
} from "../../helpers/backend_helper";
import Users from "./Users";
import Roles from "./Roles";
import "./Security.scss";

const countRecords = (response) =>
  Array.isArray(response?.data) ? response.data : [];

const securityTabs = [
  { id: 1, label: "Users", icon: "bx-user" },
  { id: 2, label: "Roles", icon: "bx-shield-quarter" },
];

const SettingsSecurity = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [createRequest, setCreateRequest] = useState({ tab: 0, version: 0 });
  const [summary, setSummary] = useState({
    users: 0,
    activeUsers: 0,
    roles: 0,
    administratorRoles: 0,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    Promise.all([getUsersList(), getApplicationRoles()])
      .then(([usersResult, rolesResult]) => {
        const users = countRecords(usersResult);
        const roles = countRecords(rolesResult);
        setSummary({
          users: users.length,
          activeUsers: users.filter(
            (user) =>
              user.status === 1 ||
              user.status === true ||
              /active/i.test(user.statusName || "")
          ).length,
          roles: roles.length,
          administratorRoles: roles.filter((role) =>
            /admin/i.test(role.name || "")
          ).length,
        });
      })
      .catch(() =>
        setSummary({
          users: 0,
          activeUsers: 0,
          roles: 0,
          administratorRoles: 0,
        })
      );
  }, []);

  const active = securityTabs.find((tab) => tab.id === activeTab);
  const canCreate = activeTab === 1;

  const requestCreate = () =>
    setCreateRequest((current) => ({
      tab: activeTab,
      version: current.version + 1,
    }));

  return (
    <div className="page-content security-page piers-page">
      <Container fluid>
        <header className="security-page__header piers-page-header">
          <div>
            <h1 className="piers-page-title">Users</h1>
            <p>Manage user access and roles for your firm.</p>
          </div>
          {canCreate && (
            <Button color="primary" type="button" onClick={requestCreate}>
              <i className="bx bx-plus" /> New {active.label.slice(0, -1)}
            </Button>
          )}
        </header>

        <SummaryCards
          items={[
            ["bx-user", "blue", "Total Users", summary.users, "All firm users"],
            [
              "bx-user-check",
              "green",
              "Active Users",
              summary.activeUsers,
              "Enabled accounts",
            ],
            [
              "bx-shield-quarter",
              "purple",
              "Roles",
              summary.roles,
              "Configured roles",
            ],
            [
              "bx-user-check",
              "orange",
              "Administrator Roles",
              summary.administratorRoles,
              "Roles with admin access",
            ],
          ]}
          ariaLabel="User management summary"
        />

        <section className="security-page__workspace">
          <nav
            className="security-page__tabs"
            aria-label="User management sections"
          >
            {securityTabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={classnames({ "is-active": activeTab === tab.id })}
                onClick={() => setActiveTab(tab.id)}
              >
                <i className={`bx ${tab.icon}`} /> {tab.label}
              </button>
            ))}
          </nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={1}>
              <Users
                createRequest={
                  createRequest.tab === 1 ? createRequest.version : 0
                }
              />
            </TabPane>
            <TabPane tabId={2}>
              <Roles />
            </TabPane>
          </TabContent>
        </section>
      </Container>
    </div>
  );
};

export default SettingsSecurity;
